const answerData = {
    typewriter: 'breadcrumb',
    buttons: 'noderw',
    floorplan: '23022311',
    telephone: '622647',
    
    portrait: '023',
    answerForm: {
        category: '364',
        subCategory: '1523',
        title: 'catching a criminal',
        author: 'philomena certain'
    }, 
    
    soundMachinePower: 'secrets',
    soundMachineButtons: ['click', 'on', 'the', 'microscope'],
    lockBox: '5643',
    pipesPassword: 'tin',
    pipes: '1682',
    
    dartsJack: 75,
    dartsBust: 100,
    cellarDoor: '72337',
    cashRegister: '012356710111315',
    directionalPad: 'lrdulr',
    safe: '215746', 
    
    clock: 'aligns',
    crates: '86710',
    powerSwitches: [
        '1', '0', '0',
        '0', '1', '1',
        '1', '0', '1'
    ],
    cogs: '9524'
}

export default answerData